import Rating from "@mui/material/Rating";

type FilterRatingProps = {
  filterName: string;
  value: number;
  precision?: number;
  onChange: (filterName: string, value: number | null) => void;
};

export default function FilterRating(props: Readonly<FilterRatingProps>) {
  const { filterName, precision, onChange, value } = props;

  return (
    <Rating
      name={filterName}
      precision={precision}
      value={value}
      onChange={(_event, newValue) => {
        onChange(filterName, newValue);
      }}
    />
  );
}
